import { Infra3DGeoserver } from "../../layer/internal";
import { AxisLoader } from "./internal";
export class AxisGRLoader extends AxisLoader {
    constructor(scene, opt_options) {
        super(scene);
        const options = opt_options || {};
        this.api = options.api || new Infra3DGeoserver(options.baseurl, options.project, scene.viewer, options.apioptions);
    }
    loadaxis(extent, srid, cbf) {
        const addconst = 0.1;
        const urlparams = {
            bbox: [
                extent.minx - addconst,
                extent.miny - addconst,
                extent.maxx + addconst,
                extent.maxy + addconst,
            ].join(),
            requestsrid: srid,
            order_by: "offset",
        };
        this.api.readfeatures("axis", (geojson) => {
            const axissegments = AxisLoader.orderByAxisId(geojson, "axisname", 0.001);
            const json = { value: axissegments };
            cbf(json);
        }, (message) => {
            console.log(message);
        }, urlparams);
    }
}
//# sourceMappingURL=gr.js.map